// A status here is a position in a journey, not a category, so it is drawn as
// one. Four segments fill as the order moves; the label names where it is.
//
// Cancelled keeps the same shape rather than switching to a badge — the point
// is that it stopped, and an empty rail says that better than a new form does.
//
// Labels are kept short and close in length. A long label next to a short one is
// what made the old pills look ragged beside the order number.

const JOURNEY = ['pending', 'accepted', 'picked_up', 'delivered']

const LABELS = {
  pending: 'Placed',
  accepted: 'Accepted',
  picked_up: 'On the way',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
}

export default function OrderStatus({ status }) {
  const cancelled = status === 'cancelled'
  const reached = JOURNEY.indexOf(status)

  return (
    <div className="flex-none flex flex-col items-end gap-1.5">
      <span
        className={`text-label font-semibold uppercase whitespace-nowrap ${
          cancelled ? 'text-alert' : 'text-brand'
        }`}
      >
        {LABELS[status] ?? status}
      </span>

      {/* The rail repeats what the label says, so it is hidden from assistive
          tech rather than read out as four anonymous boxes. */}
      <span
        aria-hidden="true"
        className="flex gap-[3px] w-16"
        title={cancelled ? 'Left the journey' : `Step ${reached + 1} of ${JOURNEY.length}`}
      >
        {JOURNEY.map((name, index) => (
          <span
            key={name}
            className={`h-[3px] flex-1 rounded-[2px] transition-colors duration-settle ease-out ${
              !cancelled && index <= reached ? 'bg-brand' : 'bg-hairline'
            }`}
          />
        ))}
      </span>
    </div>
  )
}

export { LABELS as STATUS_LABELS, JOURNEY as STATUS_JOURNEY }
